import { ActivePastCampaignDto } from "../../../../app/model/api/types/dto";
import { getFormattedDate } from "../../../../utility/helpers";
import CampaignActionButton from "./CampaignActionButton";
import { getActionConfig } from "./utility";

const CampaignCard: React.FC<{
  campaign: ActivePastCampaignDto;
  activeCampaigns?: boolean;
}> = ({ campaign, activeCampaigns }) => {
  const config = getActionConfig(campaign, activeCampaigns);

  return (
    <div className="col-12 mb-3" key={campaign.id}>
      <div className="card h-100">
        <div className="card-body">
          <h5 className="card-title">
            {campaign.name} ({campaign.code})
          </h5>
          <p className="card-text">
            {campaign.startDate && campaign.endDate
              ? `${getFormattedDate(
                  campaign.startDate.toString()
                )} - ${getFormattedDate(campaign.endDate.toString())}`
              : null}
          </p>
          <div className="d-flex mt-3 justify-content-end">
            {config && config.show ? (
              <CampaignActionButton
                label={config.label}
                campaignId={campaign.id}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignCard;
